import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ConfluenceBatchImportRequest,
  ConfluenceImportRequest,
  ConfluencePage,
  ConfluenceSpace
} from '../../../core/models/knowledge-confluence.model';
import { ImportResultResponse, SyncResultResponse } from '../../../core/models/knowledge-import-result.model';

/**
 * Navegación e importación de Confluence (RF-001/RF-003). Usa la conexión
 * Confluence del usuario resuelta en el backend; un 424 significa "sin
 * conexión activa o credencial inválida" (BR-30). El backoff ante 429 lo
 * hace el backend: si aquí llega un 429 es el error explícito tras agotar
 * los reintentos — no se reintenta en cliente (NFR-03).
 */
@Injectable({
  providedIn: 'root'
})
export class ConfluenceService {

  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.knowledgeApiUrl}/knowledge/confluence`;
  }

  listSpaces(projectId: string, page = 0, pageSize = 25): Observable<ConfluenceSpace[]> {
    return this.http.get<ConfluenceSpace[]>(`${this.baseUrl}/spaces`, {
      params: { projectId, page, pageSize }
    });
  }

  listPages(projectId: string, spaceKey: string, page = 0, pageSize = 25): Observable<ConfluencePage[]> {
    return this.http.get<ConfluencePage[]>(
      `${this.baseUrl}/spaces/${encodeURIComponent(spaceKey)}/pages`,
      { params: { projectId, page, pageSize } }
    );
  }

  getPage(projectId: string, pageId: string): Observable<ConfluencePage> {
    return this.http.get<ConfluencePage>(
      `${this.baseUrl}/pages/${encodeURIComponent(pageId)}`,
      { params: { projectId } }
    );
  }

  importPage(request: ConfluenceImportRequest): Observable<ImportResultResponse> {
    return this.http.post<ImportResultResponse>(`${this.baseUrl}/import`, request);
  }

  importPagesBatch(request: ConfluenceBatchImportRequest): Observable<ImportResultResponse> {
    return this.http.post<ImportResultResponse>(`${this.baseUrl}/import/batch`, request);
  }

  synchronize(projectId: string): Observable<SyncResultResponse> {
    return this.http.post<SyncResultResponse>(`${this.baseUrl}/synchronize`, null, {
      params: { projectId }
    });
  }
}
